module.exports = __webpack_public_path__ + "static/media/uniamc.310bef0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/uniamc.png
// module id = 472
// module chunks = 0